const TOKEN_KEY = "akhshy-dash-token";
const EXPIRES_KEY = "akhshy-dash-expires";

export interface StoredSession {
  token: string;
  expiresAt: number;
}

export function getSession(): StoredSession | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiresRaw = localStorage.getItem(EXPIRES_KEY);
  if (!token || !expiresRaw) return null;
  const expiresAt = Number(expiresRaw);
  if (!Number.isFinite(expiresAt) || expiresAt * 1000 <= Date.now()) return null;
  return { token, expiresAt };
}

export function getToken(): string | null {
  return getSession()?.token ?? null;
}

export function saveSession(token: string, expiresAt: number): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_KEY, String(expiresAt));
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
}
